import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash';
import { avatarUrl, formatDate } from '../../utils/Formatters';
import AccountPlayerDetails from './AccountPlayerDetails';
import AccountPlayerPlaysSummary from './AccountPlayerPlaysSummary';
import AccountPlayerStats from './AccountPlayerStats';
import { appNamedRoutes, linkWithParams } from '../../routes';
import { isAdminDashboard, isEditable, isASQEnabled, isChatEnabled } from '../../utils/authScopes';
import { Link } from 'react-router-dom';
import qrstr from 'query-string';

export default class AccountPlayer extends React.Component {
  static propTypes = {
    accountPlayer: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    backLink: PropTypes.object.isRequired,
    cohorts: PropTypes.arrayOf(PropTypes.object).isRequired,
    tabIdx: PropTypes.number.isRequired,
    onClickMore: PropTypes.func.isRequired,
    onGoBack: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onResetCohorts: PropTypes.func.isRequired,
  };

  render() {
    const { auth, accountPlayer, backLink, cohorts, tabIdx, onClickMore, onGoBack, onUpdate, onResetCohorts } = this.props;

    if (isEmpty(accountPlayer)) return null;
    if (get(accountPlayer, 'deleted')) { onGoBack(backLink); return null; }
    const bg = { backgroundImage: avatarUrl(accountPlayer) };
    const editable = isEditable(auth);
    const engagement = [accountPlayer.stats.plays.total, accountPlayer.stats.plays.range];
    const interactivity = [accountPlayer.stats.uploads.total, accountPlayer.stats.uploads.range];
    const asqs = accountPlayer.currentAsq;
    let isNotEmpty = false;
    let asq;
    if (asqs !== 'undefined' && asqs.length > 0) {
      isNotEmpty = true
    }
    return (
      <div className='column small-12 medium-3'>
        <div className='u-flex u-margin-bottom--base'>
          <div style={bg} className='o-avatar o-avatar--base u-margin-right--base'></div>
          <div>
            <div className='flex-container'>
              <div>
                <span className='u-txt--header'>{accountPlayer.firstName}</span><br />
                <span className='u-txt--header'>{accountPlayer.lastName}</span>
              </div>
              {isChatEnabled(auth) &&
                <div className='padding-left-1'>
                  <Link className='cs-txt-link--sp-blue'
                    to={{
                      pathname: appNamedRoutes.communicationDashboard,
                      search: `?id=${accountPlayer.id}`
                    }}
                    title="Coaching">
                    <i className='fa fa-comments-o'></i>
                  </Link>
                </div>}
            </div>
            <br />
            <span className='u-txt--label'>Age</span><br />
            <span><b>{accountPlayer.formattedAge}</b></span><br />
            {isASQEnabled(auth) && isNotEmpty ?
              <span>
                <Link className='cs-txt-link--sp-blue' to={{ pathname: linkWithParams('asqs'), search: qrstr.stringify({ player: accountPlayer.id }) }}>
                  ASQ Surveys
                </Link>
              </span> : ''}
          </div>
        </div>
        <div className='o-card__wrap'>
          <AccountPlayerDetails accountPlayer={accountPlayer} cohorts={cohorts} onUpdate={onUpdate} onResetCohorts={onResetCohorts} editable={editable} />
        </div>
        <AccountPlayerStats title='Engagement' data={engagement.slice(0, 1)} />
        <AccountPlayerStats title='Interactivity' data={interactivity.slice(0, 1)} />
        <AccountPlayerPlaysSummary plays={accountPlayer.plays} tabIdx={tabIdx} onClickMore={onClickMore} />
        <div className='o-card__wrap'>
          <section className='column o-card cs-bg--light'>
            {isAdminDashboard(auth) &&
              <p className='u-margin-bottom--tiny'>
                <span className='u-txt--label'>Partner</span><br />
                {accountPlayer.partner}
              </p>}
            <p className='u-margin-bottom--tiny'>
              <span className='u-txt--label'>Application Locale</span><br />
              {accountPlayer.locale}
            </p>
            <p className='u-margin-bottom--tiny'>
              <span className='u-txt--label'>Last App Touch</span><br />
              {formatDate(accountPlayer.lastAppTouch)}
            </p>
          </section>
        </div>
      </div>
    );
  }
}
